const CLIENT_IP_ENDPOINT = "https://api64.ipify.org?format=json";
const CLIENT_IP_CACHE_DURATION = 5 * 60 * 1000;
const CLIENT_IP_TIMEOUT = 3000;

let cachedIpAddress = null;
let cachedAt = 0;
let pendingRequest = null;

const normalizeIpAddress = (value) => {
  if (typeof value !== "string") return null;

  const ipAddress = value.trim();
  return ipAddress && /^[0-9a-f:.]+$/i.test(ipAddress)
    ? ipAddress
    : null;
};

const requestClientIpAddress = async () => {
  const controller =
    typeof AbortController !== "undefined" ? new AbortController() : null;
  const timeout = setTimeout(() => controller?.abort(), CLIENT_IP_TIMEOUT);

  try {
    const response = await fetch(CLIENT_IP_ENDPOINT, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
      signal: controller?.signal,
    });

    if (!response.ok) {
      throw new Error(`Unable to resolve client IP (${response.status})`);
    }

    const data = await response.json();
    return normalizeIpAddress(data?.ip);
  } finally {
    clearTimeout(timeout);
  }
};

export const getClientIpAddress = async () => {
  const cacheIsValid =
    cachedIpAddress && Date.now() - cachedAt < CLIENT_IP_CACHE_DURATION;

  if (cacheIsValid) {
    return cachedIpAddress;
  }

  if (!pendingRequest) {
    pendingRequest = requestClientIpAddress()
      .then((ipAddress) => {
        if (ipAddress) {
          cachedIpAddress = ipAddress;
          cachedAt = Date.now();
        }

        return ipAddress || cachedIpAddress;
      })
      .catch((error) => {
        console.warn("Unable to resolve client IP address:", error.message);
        return cachedIpAddress;
      })
      .finally(() => {
        pendingRequest = null;
      });
  }

  return pendingRequest;
};
